import {
    Stack,
    ToggleButton,
    ToggleButtonOption,
    ToggleButtonOptionGroup,
    type ToggleButtonProps,
} from "@octopus-energy/coral/atoms"
import { token } from "@octopus-energy/coral-design/tokens"
import { useTranslations } from "next-intl"
import { MarketName } from "@/constants/marketName"
import { MarketNameIcon } from "../MarketNameIcon"

export type MarketTypeToggleProps = Pick<ToggleButtonProps<MarketName>, "value" | "onChange">

const MARKET_NAMES = Object.values(MarketName)

export function MarketTypeToggle(props: MarketTypeToggleProps) {
    const t = useTranslations("MarketTypeToggle")

    return (
        <ToggleButton
            fullWidth
            size="small"
            {...props}
        >
            <ToggleButtonOptionGroup>
                <Stack gap="xxs">
                    {MARKET_NAMES.map((marketName) => (
                        <ToggleButtonOption
                            key={marketName}
                            value={marketName}
                        >
                            <MarketNameIcon
                                size={16}
                                marketName={marketName}
                                color={token("colors.contents.base.900")}
                            />
                            &nbsp;{t("label", { marketName })}
                        </ToggleButtonOption>
                    ))}
                </Stack>
            </ToggleButtonOptionGroup>
        </ToggleButton>
    )
}

MarketTypeToggle.messages = ["MarketTypeToggle"] as const
